import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface CouponTableSkeletonProps {
  rowCount?: number;
}

export function CouponTableSkeleton({
  rowCount = 5,
}: CouponTableSkeletonProps) {
  return (
    <Card className="w-full border-0 shadow-sm card-modern">
      <CardHeader className="bg-white rounded-t-lg border-b border-gray-100 py-3 px-4">
        <CardTitle className="text-lg font-medium text-gray-800">
          <Skeleton className="h-6 w-40" />
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="w-full overflow-auto">
          <Table>
            <TableHeader className="bg-gray-50">
              <TableRow className="border-b border-gray-200">
                {Array(9)
                  .fill(0)
                  .map((_, index) => (
                    <TableHead
                      key={index}
                      className="text-gray-600 font-bold py-4"
                    >
                      <Skeleton className="h-4 w-20" />
                    </TableHead>
                  ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {Array(rowCount)
                .fill(0)
                .map((_, rowIndex) => (
                  <TableRow
                    key={rowIndex}
                    className="hover:bg-gray-50 border-b border-gray-100"
                  >
                    {Array(9)
                      .fill(0)
                      .map((_, colIndex) => (
                        <TableCell
                          key={colIndex}
                          className="py-6 text-gray-700"
                        >
                          <Skeleton className="h-4 w-full" />
                        </TableCell>
                      ))}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
